import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { AdsSummaryResponse } from '@brand24-original/llm-types';
import { AdsFilters, getAdsSummary } from '../../services/ads/AdsService';
import { GET_ADS_SUMMARY } from '../../query/ads/keys';

export const useGetAdsSummary = (
  projectId: number | null,
  from: Date | null,
  to: Date | null,
  filters: AdsFilters,
  enabled = true
) => {
  const queryEnabled = !!projectId && !!from && !!to && enabled;

  const { data, isLoading, isError, refetch } = useQuery<AdsSummaryResponse>({
    queryKey: [GET_ADS_SUMMARY, projectId, from, to, filters.models, filters.promptIds, filters.advertisers],
    queryFn: () => getAdsSummary(projectId!, from!, to!, filters),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
    placeholderData: keepPreviousData,
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
